export const ChannelMode = {
  Auto: "auto",
  Manual: "manual",
} as const

export type ChannelMode = typeof ChannelMode[keyof typeof ChannelMode]
